module.exports = __webpack_public_path__ + "img/404.f5eb55f0.png";